import { Sparkles, Loader2 } from 'lucide-react';
import { AdminPageHeader, useFetcher } from './_P1Common';

export default function AdminAIRecommendations() {
  const { data, loading } = useFetcher('ai-recommendations');
  if (loading || !data) return <AdminPageHeader icon={Sparkles} title="AI preporuke"><Loader2 className="animate-spin"/></AdminPageHeader>;
  return (
    <div data-testid="admin-ai-recommendations">
      <AdminPageHeader icon={Sparkles} title="AI preporuke sadržaja" subtitle="Članci koji zaslužuju poboljšanje naslova, slike ili SEO meta oznaka"/>
      <div className="px-4 md:px-6 pb-6 space-y-2 max-w-4xl">
        {(data.items || []).map(r => (
          <div key={r.id} data-testid={`ai-rec-${r.id}`} className="border border-zinc-800 rounded p-3 bg-zinc-900/40">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <a href={`/clanak/${r.slug}`} target="_blank" rel="noreferrer" className="font-bold hover:text-red-400 truncate block">{r.title}</a>
                <div className="text-xs text-zinc-500 mt-1">{r.category || '—'} · {r.views || 0} pregleda</div>
                <div className="text-sm text-amber-300 mt-1">{r.recommendation}</div>
              </div>
              <span className="text-xs px-2 py-1 rounded bg-red-900/40 text-red-200">Score {r.score}</span>
            </div>
          </div>
        ))}
        {(data.items || []).length === 0 && <p className="text-center text-zinc-500 py-8">Nema preporuka — svi članci rade dobro.</p>}
      </div>
    </div>
  );
}
